import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
// import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

import Renderer from 'component/gl/renderer';

// const dracoLoader = new DRACOLoader();
// dracoLoader.setDecoderPath('/draco/');

const tl = new GLTFLoader();
// tl.setDRACOLoader(dracoLoader);

const GLTFCache = new Map();

const preCompile = (object) => {
    const scene = Renderer.getInstance().scene;

    scene.add(object);

    Renderer.getInstance().render();

    scene.remove(object);
};

export default function loadGLTF(url) {
    return new Promise((resolve) => {
        let data = GLTFCache.get(url);

        if (data) {
            data = { ...data };
            // manually clone gltf when needed
            // data.scene = data.scene.clone();
            resolve(data);
        } else {
            tl.load(url, (d) => {
                GLTFCache.set(url, d);
                d = { ...d };
                // manually clone gltf when needed
                // d.scene = d.scene.clone();
                preCompile(d.scene);
                resolve(d);
            });
        }
    });
}
